module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_photogenic@3x-6b09f2d6cea191a1f4727194461329a1.webp";